jQuery(document).ready(function(){

  $(document).on("click", ".custom-gorgias-chat-popup",function(){
    // if($(`#chat-window`).hasClass('gorgias-chat-key-1pn7ot0')){
    //   $(`#chat-window`).removeClass('gorgias-chat-key-1pn7ot0').addClass('gorgias-chat-key-16g1rws');
    // } else {
    //   $(`#chat-window`).removeClass('gorgias-chat-key-16g1rws').addClass('gorgias-chat-key-1pn7ot0');
    // }
    //find iframe
    let iframe = $('#chat-button');
    let button;

    if($(window).width() > 767){
      //find button inside iframe
      button = iframe.contents().find('.messenger-button-iframe-qnqyme');
    } else {
      //find button inside iframe
      button = iframe.contents().find('.messenger-button-iframe-bquijq');      
    }

    //trigger button click
    button.trigger("click");
  })

  // This button will increment the value
  $('.qtyplus').click(function(e){
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[id='+fieldName+']').val());
    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      $('input[id='+fieldName+']').val(currentVal + 1);
    } else {
      // Otherwise put a 0 there
      $('input[id='+fieldName+']').val(0);
    }
  });
  // This button will decrement the value till 0
  $(".qtyminus").click(function(e) {
    // Stop acting like a button
    e.preventDefault();
    // Get the field name
    fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt($('input[id='+fieldName+']').val());
    // If it isn't undefined or its greater than 0
    if (!isNaN(currentVal) && currentVal > 0) {
      // Decrement one
      $('input[id='+fieldName+']').val(currentVal - 1);
    } else {
      // Otherwise put a 0 there
      $('input[id='+fieldName+']').val(0);
    }
  });
  // Initial display of cart items
  displayCart();
});
$('.slide-remove-item').on('click', function(event){
  event.preventDefault();
  var productId = parseInt($(this).attr('data-id'));
  jQuery.post('/cart/update.js', 'updates['+productId+']=0')
  .done(function() {
    // console.log("success");
    window.location.reload();
  })
  .fail(function() {
    // console.log("error");
  })
  .always(function() {
    // console.log("complete");
    window.location.reload();
  });
});
Shopify.removeItem = function(variant_id, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=0&id='+variant_id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
        window.location.reload();

      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};
$(window).ready(function() {
  if($('.flexslider').length > 0){
    $('.flexslider').flexslider({
      animation: "slide"
    });
  }
});
// Sample cart items with weights
const cartItems = [
  {
    name: "Item 1",
    weight: 2
  },
  {
    name: "Item 2",
    weight: 3
  },
  {
    name: "Item 3",
    weight: 1
  },
];
// Function to add cart items to the list
function displayCart() {
  const cartList = document.getElementById("cart");
  cartList.innerHTML = "";
  cartItems.forEach(item => {
    const li = document.createElement("li");
    li.textContent = `${item.name} (Weight: ${item.weight} lbs)`;
    cartList.appendChild(li);
  });
}
// Function to calculate shipping cost
function calculateShipping() {
  const zipCodeInput = document.getElementById("zipCode");
  const zipCode = zipCodeInput.value;
  // Perform an API call or calculation based on zip code and cart weight
  // In this example, we'll assume a fixed rate of $0.5 per pound
  const totalWeight = cartItems.reduce((total, item) => total + item.weight, 0);
  const shippingCost = totalWeight * 0.5;
  // Display the shipping cost
  const shippingCostDisplay = document.getElementById("shippingCost");
  shippingCostDisplay.textContent = `Shipping Cost to ${zipCode}: $${shippingCost.toFixed(2)}`;
}

function numberWithCommas(x) {
    return x.toString().split('.')[0].length > 3 ? x.toString().substring(0,x.toString().split('.')[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + x.toString().substring(x.toString().split('.')[0].length-3): x.toString();
}

(function loop() {
  var cart_update = setTimeout(() => {
    // Your logic here
    if($(`.rebuy-cart.is-visible`).length > 0){
      $.getJSON('/cart.js', function(cart) {
        var cart_items = cart.item_count;
        var cart_total = (cart.total_price / 100).toFixed(2);
        console.log('cart_total',cart_total);
        $(`#cart-price-wrap,.site-header__cart .price_text`).text('$'+numberWithCommas(cart_total));
        $(`.site-header__cart-count span`).text(cart_items);
        clearInterval(cart_update);
      })
    }
    loop();
  }, 1000);
})();